module.exports = __webpack_public_path__ + "img/73ae2c96-d7db-467d-9bc7-330f494cf2ee.7794523c.jpg";